export default "__VITE_PUBLIC_ASSET__c5d1476d__"